import type { BookCreateRequest, BookItem, BookUpdateRequest } from '@ayub/shared'
import { apiDelete, apiGet, apiPatch, apiPost } from '@/lib/api'

/** `GET /api/books` — barcha kitoblar (eng yangisi tepada). */
export function fetchBooks(): Promise<BookItem[]> {
  return apiGet<BookItem[]>('/books')
}

/** `POST /api/books` — yangi kitob (faqat super admin). */
export function createBook(body: BookCreateRequest): Promise<BookItem> {
  return apiPost<BookItem>('/books', body)
}

/** `PATCH /api/books/:id` — kitobni tahrirlash (faqat super admin). */
export function updateBook(id: number, body: BookUpdateRequest): Promise<BookItem> {
  return apiPatch<BookItem>(`/books/${id}`, body)
}

/** `DELETE /api/books/:id` — kitobni o'chirish (faqat super admin). */
export function deleteBook(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/books/${id}`)
}
